export const ChatMessageType = {
  Text: "text",
  Audio: "audio",
  DateSeparator: "date-separator",
  Reaction: "reaction",
  Call_Log: 'call_log',
};
